import React, { useState, useEffect, useCallback } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Card, CardHeader, CardContent, TextField, Grid, Button, colors, Autocomplete } from '@mui/material';

import { enqueueSnackbar } from 'actions';

import DataTable2G from './components/DataTable2G';
import DataTable3G from './components/DataTable3G';
import DataTable4G from './components/DataTable4G';
import DataTable5G from './components/DataTable5G';

import { GetSites, SetSelected, GetSite, EditValue, UpdateSelectedRows, RunAlgoPlan, CreateScripts } from '../../actions/PlanningActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	paper: {
		padding: theme.spacing(1),
	},
	popover: {
		pointerEvents: 'none',
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const Planning = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const sites = useSelector(state => state.planningReducer.sites);
	const selected = useSelector(state => state.planningReducer.selected);
	const site = useSelector(state => state.planningReducer.site);
	const selectedRows = useSelector(state => state.planningReducer.selectedRows);
	const user = useSelector(state => state.session.user);

	const _setSelected = (value) => {
		dispatch(SetSelected(value));
	};

	const _getSite = () => {
		dispatch(GetSite(selected.siteId));
	};

	const _editValue = (data, tech) => {
		dispatch(EditValue(data, tech));
	};

	const _plan = () => {
		// dispatch(RunAlgoPlan(selected.siteId));
	};

	const _scripts = () => {
		dispatch(CreateScripts(selectedRows, 'tfbr-ericsson-commissioning', user.id));
	};

	const _getData = useCallback(() => {
		dispatch(GetSites());
	}, []);

	useEffect(() => {
		_getData();
	}, [_getData]);

	const _updateSelectedRows = (updatedSelectedRows, tech) => {
		dispatch(UpdateSelectedRows(updatedSelectedRows, tech));
	};

	return (

		<div className={clsx(classes.container)}>
			<Card className={classes.container}>
				<CardContent>
					<Grid container spacing={2}>
						<Grid item md={6} xs={12}>
							<Autocomplete
								id="auto-complete"
								options={sites}
								value={selected}
								getOptionLabel={(option) => option.siteId}
								renderInput={(params) => <TextField {...params} label="Site Id" variant="outlined" />}
								onChange={(event, value) => { _setSelected(value); }}
							/>
						</Grid>
						<Grid item md={1} xs={12} spacing={1}>
							<Button disabled={!selected} color="primary" variant="contained" size="large" onClick={_getSite}>Search</Button>
						</Grid>
						<Grid item md={2} xs={12} spacing={1}>
							<Button disabled color="primary" variant="contained" size="large" onClick={_plan}>Algo Plan</Button>
						</Grid>
						<Grid item md={2} xs={12} spacing={1}>
							<Button disabled={!site} className={classes.generate} variant="contained" size="large" onClick={_scripts}>Create Scripts</Button>
						</Grid>
					</Grid>

				</CardContent>
			</Card>

			{site && <DataTable2G className={classes.container} data={site.builderCells2g} editValue={_editValue} updateSelectedRows={_updateSelectedRows} />}
			{site && <DataTable3G className={classes.container} data={site.builderCells3g} editValue={_editValue} updateSelectedRows={_updateSelectedRows} />}
			{site && <DataTable4G className={classes.container} data={site.builderCells4g} editValue={_editValue} updateSelectedRows={_updateSelectedRows} />}
			{site && <DataTable5G className={classes.container} data={site.builderCells5g} editValue={_editValue} updateSelectedRows={_updateSelectedRows} />}
		</div>
	);
};

export default Planning;
